/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import { observer } from 'mobx-react';
import React from 'react';
import './layout.scss';
import ImageWithTextCommonLayout from './imageWithTextCommonLayout';

export default observer(({
    bannerItem, bannerSectionId, bannerPlatform, appConfig, appsSkeletonModel,
}) => (
    <ImageWithTextCommonLayout
        bannerItem={bannerItem}
        bannerSectionId={bannerSectionId}
        bannerPlatform={bannerPlatform}
        appConfig={appConfig}
        appsSkeletonModel={appsSkeletonModel}
        parentBannerLayout="imageWithTextOnLeft" />
));
